const mode = {
  DELIVERY: "delivery",
  PICKUP: "pickup"
}

export const ORDER_MODE = Object.freeze(mode);
